import React, { ReactNode } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Typography } from '@mui/material';
import { colors } from '../../styles';

interface BaseNodeProps {
  label: string;
  typeLabel: string;
  accent: string;
  icon?: ReactNode;
}

export const NODE_WIDTH = 210;

const BaseNode: React.FC<BaseNodeProps> = ({ label, typeLabel, accent, icon }) => {
  const handleStyle = {
    width: 7,
    height: 7,
    background: colors.brand.surface,
    border: `1.5px solid ${accent}`,
  };

  return (
    <Box
      title={label}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        width: NODE_WIDTH,
        boxSizing: 'border-box',
        padding: '8px 10px',
        borderRadius: '10px',
        backgroundColor: colors.brand.surface,
        border: `1px solid ${accent}55`,
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.35)',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        '&:hover': { borderColor: accent, boxShadow: `0 0 0 3px ${accent}22` },
      }}
    >
      <Handle type="target" position={Position.Top} style={handleStyle} />
      <Box
        sx={{
          width: 28,
          height: 28,
          flexShrink: 0,
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: accent,
          backgroundColor: `${accent}1F`,
          '& svg': { fontSize: 17 },
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          sx={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: '9px',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: colors.brand.textMuted,
            lineHeight: 1.3,
          }}
        >
          {typeLabel}
        </Typography>
        <Typography
          noWrap
          sx={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: '12.5px',
            fontWeight: 500,
            color: colors.primary.white,
            lineHeight: 1.35,
          }}
        >
          {label}
        </Typography>
      </Box>
      <Handle type="source" position={Position.Bottom} style={handleStyle} />
    </Box>
  );
};

export default BaseNode;
